import { GESTION_OPERATIVA_SET_IS_MODIFIED } from './constants'

export function setIsModified(status) {
    return (dispatch) => {
        dispatch({
            type: GESTION_OPERATIVA_SET_IS_MODIFIED,
            data: status
        })
    }
}

export function reducer(state, action){
    if (action.type === GESTION_OPERATIVA_SET_IS_MODIFIED) {
            return {
                ...state,
                isModified: action.data
            }
    }        
    else {
             return state
    }
}